module.exports = __webpack_public_path__ + "static/media/logo-itesa.a300d56d.png";